import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class RechargeService {
  // Create recharge request
  createRecharge(amount, channel = 'Channel 01') {
    return axios.post(config.api.recharge + '/create', {
      amount,
      channel
    }, {
      headers: authHeader()
    });
  }

  // Get user's recharge history
  getUserRecharges() {
    const user = JSON.parse(localStorage.getItem('user'));
    const username = user ? user.username : '';
    return axios.get(config.api.recharge + '/user/' + username, {
      headers: authHeader()
    });
  }

  // Admin: Get all recharge requests
  getAllRecharges() {
    return axios.get(config.api.admin + '/recharges', {
      headers: authHeader()
    });
  }

  // Admin: Approve recharge
  approveRecharge(rechargeId) {
    return axios.post(config.api.admin + '/recharge/approve', { rechargeId }, {
      headers: authHeader()
    });
  }

  // Admin: Reject recharge
  rejectRecharge(rechargeId) {
    return axios.post(config.api.admin + '/recharge/reject', { rechargeId }, {
      headers: authHeader()
    });
  }

  // Admin: Delete recharge (extra useful)
  deleteRecharge(rechargeId) {
    return axios.delete(config.api.recharge + '/admin/delete/' + rechargeId, {
      headers: authHeader()
    });
  }
}

export default new RechargeService();